import style from "./CdmHeaderBar.module.css";

// Compact overview header: programme title + summary on the left, the CDM
// actions (start review / view PCRS details / deregister) on the right.
// While the page data loads it renders its own loading state so the layout
// stays stable instead of swapping in a separate section.
export const CdmHeaderBar = ({ title, subtitle, actions, loading = false }) => {
  if (loading) {
    return (
      <div className={style.bar} aria-busy="true">
        <div className={style.text}>
          <h3 className={style.title}>Loading…</h3>
          <p className={style.subtitle}>
            We are loading the data for this patient.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={style.bar}>
      <div className={style.text}>
        {!!title && <h3 className={style.title}>{title}</h3>}
        {!!subtitle && <p className={style.subtitle}>{subtitle}</p>}
      </div>
      {!!actions && <div className={style.actions}>{actions}</div>}
    </div>
  );
};
